// extracted by mini-css-extract-plugin
export var emailBlockLink = "_in-0";